import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Redirect } from 'react-router-dom';

@inject('customerCaseStore')
@observer
export default class AuthWithKey extends Component {
	  constructor(props) {
		      super(props);

		      var key = props.match.params.key;
		      props.customerCaseStore.logout();
		      props.customerCaseStore.userLoginWithKey(key);
		    }

	  render() {
		      if (this.props.customerCaseStore.currentUser != null) {
			            return <Redirect to="/cases/"/>;
			          }

		      return (
			            <div></div>
			          );
		    }
}




// WEBPACK FOOTER //
// ./src/views/AuthWithKey/AuthWithKey.jsx